export default __webpack_public_path__ + "static/media/mercado_livre.7e94a9bd.png";